export enum VisitType {
  Booking,
  Bill
}
